import { AxiosError } from 'axios';

import { USER_BACKGROUND_API_URL } from '@/constants/apis';
import { apiManager } from '@/helpers/api.manager';
import { ApiResponse } from '@/types/response.type';
import { LeadBackground } from '@/types/zee-candidate.type';

export const getLeadBackground = async (
  leadId: string
): Promise<ApiResponse<LeadBackground>> => {
  try {
    const response = await apiManager.get(
      `${USER_BACKGROUND_API_URL}/${leadId}/background`,
      {
        headers: { 'Content-Type': 'application/json' },
      }
    );

    if (response.status !== 200) {
      const error = response as unknown as AxiosError;
      return Promise.reject(error.response?.data);
    }

    return Promise.resolve(response.data);
  } catch (e) {
    return Promise.reject(e);
  }
};
